import Text from 'components/_UI/Text';
import React, { useState } from 'react'
import styled from 'styled-components'
import { FullyCentered } from 'styled/alignment/Center';
import colors from 'theme/colors';
import fonts from 'theme/fonts';

// A letra ocupa no máximo 40% da largura do avatar (cqw = 1% da largura do
// próprio avatar). Com o tamanho fixo de antes (24px no padrão), a inicial
// tomava dois terços de um avatar de 36px e estourava um de 24px.
const MAX_LETTER_SHARE = '40cqw';

export default function DynamicProfileImage({
    img,
    size,
    word,
    textSize = 'title',
    variant = 'rounded',
    bgColor = colors.secondary,
    onClick = () => false,
    onMouseEnter = () => false,
    onMouseLeave = () => false,

}) {
    const [hasError, setHasError] = useState(false);
    const showImage = img && !hasError;

    return (
        showImage
            ? (
                <Picture
                    size={size}
                    onClick={onClick}
                    onMouseEnter={() => onMouseEnter()}
                    onMouseLeave={() => onMouseLeave()}
                >
                    <ImageBackground
                        src={img}
                        alt='imagem de perfil'
                        size={size}
                        variant={variant}
                        onError={() => setHasError(true)}
                    />
                </Picture>
            )
            : (
                <TextContent
                    bgColor={bgColor}
                    variant={variant}
                    size={size}
                    letterSize={fonts.sizes[textSize] || fonts.sizes.default}
                >
                    <Text
                        color={colors.neutral}
                        type='bold'
                        name={textSize}
                    >
                        {word?.charAt(0).toUpperCase()}
                    </Text>
                </TextContent>
            )
    )
}

const Picture = styled.picture`
    ${({ size }) => size && `
        width: ${size};
        height: ${size};
    `}
`;

const ImageBackground = styled.img`
    ${({ size }) => size && `
        width: ${size};
        height: ${size};
        object-fit: cover;
    `}

    ${({ variant }) => variant === 'rounded' && `
        border-radius: 60px;
    `}

    ${({ variant }) => variant === 'squired' && `
        border-radius: 6px;
    `}
`;

const TextContent = styled(FullyCentered)`
    ${({ bgColor }) => bgColor && `
        background: ${bgColor};
    `}

    ${({ size }) => size && `
        width: ${size};
        height: ${size};
        container-type: inline-size;
    `}

    ${({ variant }) => variant === 'rounded' && `
        border-radius: 60px;
    `}

    ${({ variant }) => variant === 'squired' && `
        border-radius: 6px;
    `}

    p, h1, h2, h3, h4 {
        padding-bottom: 0 !important;
    }

    ${({ size, letterSize }) => size && `
        p, h1, h2, h3, h4 {
            font-size: min(${letterSize}, ${MAX_LETTER_SHARE}) !important;
        }
    `}
`;
